import "dayjs/locale/pt-br";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

export function formatDateSince(date: string) {
	const dateFormatted = dayjs(date, "DD-MM-YYYY HH:mm")
		.locale("pt-br")
		.format("MMMM [de] YYYY");

	return dateFormatted.charAt(0).toUpperCase() + dateFormatted.slice(1);
}

export function formatDateNotification(date: string) {
	// Tentar primeiro ISO/parse nativo; se falhar, usar formatos conhecidos
	const isoParsed = dayjs(date);
	if (isoParsed.isValid()) {
		return isoParsed.locale("pt-br").fromNow();
	}

	const formats = [
		"YYYY-MM-DD HH:mm:ss",
		"YYYY-MM-DDTHH:mm:ssZ",
		"YYYY-MM-DDTHH:mm:ss.SSSZ",
		"DD-MM-YYYY HH:mm",
		"DD/MM/YYYY HH:mm",
	];

	for (const fmt of formats) {
		const d = dayjs(date, fmt, true);
		if (d.isValid()) {
			return d.locale("pt-br").fromNow();
		}
	}

	// Fallback: retorna "agora" se não reconhecido
	return dayjs().locale("pt-br").fromNow();
}

export function formatDate(date: string) {
	const dateFormatted = date.split(" ")[0];

	const parsedDate = dayjs(dateFormatted, "DD-MM-YYYY", true);

	if (!parsedDate.isValid()) {
		console.log("Invalid date", dateFormatted);
		return null;
	}

	return parsedDate.locale("pt-br").format("DD [de] MMMM [de] YYYY");
}

export function formatCommentDate(date: string) {
	const formattedDate = dayjs(date, "DD-MM-YYYY HH:mm")
		.locale("pt-br")
		.format("DD.MM.YYYY [às] HH[h]mm");

	return formattedDate;
}
